import useFeatureFlags from '@sorare/core/src/hooks/useFeatureFlags';

import { RivalsSquadComingSoon } from 'components/rivals/squads/RivalsSquadComingSoon';
import { SquadsRedirect } from 'components/rivals/squads/SquadsRedirect';

const MySquadPage = () => {
  const {
    flags: { comingSoonRivalsSquads = false },
  } = useFeatureFlags();

  if (comingSoonRivalsSquads) {
    return <RivalsSquadComingSoon />;
  }

  return <SquadsRedirect />;
};
export default MySquadPage;
